<template>
  <dynamic-modal @apply-cb="apply" title="" name="campaign-gate-reward-modal" :show-footer="false">
    <template #body>
      <div v-if="reward.type === 'coupon_code'" class="reward-modal-content">
        <h1 class="reward-modal-content-thanks">Thank’s</h1>
        <h2 class="reward-modal-content-msg" v-if="reward.description">{{reward.description}}</h2>
        <div class="reward-modal-content-item coupon-code-item">
          <div class="reward-modal-content-item-prize" style="margin-top: 20px;">
            <p>Your code</p>
            <div class="reward-link">
              <p>{{reward.source}}</p>
              <img @click="showNotification()" v-clipboard:copy="reward.source" src="~@/assets/campaign-gate/copy.svg" alt="Copy to clipboard"/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="reward.type === 'link'" class="reward-modal-content">
        <h1 class="reward-modal-content-thanks">Thank’s</h1 >
        <div class="reward-modal-content-msg" v-if="reward.description">
          <p>{{reward.description}}</p>
        </div>
        <a :href="reward.source" target="_blank" style="margin-bottom: 24px;margin-top: 14px;">{{reward.source}}</a>
        <div class="reward-modal-content-item">
          <div class="reward-modal-content-item-btn">
            <b-button @click="goToLink(reward.source)" custom-class="reward-modal-link-btn" type="blue-btn" variant="normal">Open link</b-button>
          </div>
        </div>
      </div>
      <div v-if="reward.type === 'image'" class="reward-modal-content">
        <h1 class="reward-modal-content-thanks">Thank’s</h1>
        <h2 class="reward-modal-content-msg" v-if="reward.description">{{reward.description}}</h2>
        <div style="width: 100%;margin-top: 10px;">
          <img style="width: 100%;" :src="reward.source" alt="">
        </div>
        <div class="reward-modal-content-item" style="margin-top: 20px">
<!--          <div class="reward-modal-content-item-prize">-->
<!--            <p>Your code</p>-->
<!--            <div class="reward-link"><p>sale2023</p><img src="~@/assets/campaign-gate/copy.svg" alt="Copy to clipboard"/></div>-->
<!--          </div>-->
          <div class="reward-modal-content-item-btn">
            <a class="reward-download" :href="reward_source" download="FanfrickReward">
              <span class="text-white">Download image</span>
            </a>
          </div>
        </div>
      </div>
      <div v-if="reward.type === 'file'" class="reward-modal-content">
        <h1 class="reward-modal-content-thanks">Thank’s</h1>
        <h2 class="reward-modal-content-msg" v-if="reward.description">{{reward.description}}</h2>
        <div class="reward-modal-content-item" style="margin-top: 20px">
          <!--          <div class="reward-modal-content-item-prize">-->
          <!--            <p>Your code</p>-->
          <!--            <div class="reward-link"><p>sale2023</p><img src="~@/assets/campaign-gate/copy.svg" alt="Copy to clipboard"/></div>-->
          <!--          </div>-->
          <div class="reward-modal-content-item-btn">
            <a class="reward-download" :href="reward.source" download="FanfrickReward">
              <span class="text-white">Download file</span>
            </a>
          </div>
        </div>
      </div>
    </template>
  </dynamic-modal>
</template>
<script>
import Vue from 'vue'
import DynamicModal from "@/components/__new_ui_kit/Modal/DynamicModal";
import BButton from "@/components/__new_ui_kit/Button/BButton";
export default Vue.extend({
  components: {
    BButton,
    DynamicModal

  },
  props: {
    reward: {
      type: Object
    },
    reward_source: {
      type: String
    }
  },
  data() {
    return {}
  },
  methods: {
    showNotification() {
      this.$store.dispatch('createNotification', {
        type: 'success',
        message: 'Coupon copied to clipboard'
      })
    },
    apply(applyCb) {

    },
    goToLink(url) {
      document.location.href = url
    }
  }
})
</script>
<style lang="scss" scoped>;
.reward-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  &-thanks {
    font-family: "Amatic SC", sans-serif;
    line-height: 52px;
    font-size: 48px;
    color: #000;
    font-weight: 700;
    text-align: center;
  }
  &-msg {
    margin: 32px auto 10px;
    font-family: "Levenim MT", sans-serif;
    line-height: 24px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    max-width: 203px;
  }
  &-item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    width: 100%;
    p {
      font-family: "Levenim MT", sans-serif;
      font-size: 16px;
      line-height: 24px;
    }
    &-prize {
      > p {
        color: #000;
        text-align: center;
      }
      .reward-link p {
        color: #D91B5B;
      }
      .reward-link {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        img {
          cursor: pointer;
        }
      }
    }
    &-btn {
      .reward-modal-link-btn {
        font-family: "Amatic SC", sans-serif;
        font-weight: 700;
        font-size: 32px;
        // line-height: 45px;
        color: white;
        height: 64px;
        @media (max-width: 991px) {
          height: 50px;
        }
        background-color: #D91B5B;
        &:hover {
          background-color: #D91B5BCF;
        }
      }
    }
  }
  &-item.coupon-code-item {
    justify-content: center;
  }
  .reward-download {
    width: 100%;
    height: 64px;
    padding: 0 20px;
    margin-top: 24px;
    color: #fff;
    border-radius: 8px;
    background: #d91b5b;
    box-shadow: 0 15px 45px 0 rgba(202,0,68,.2);
    font-family: Amatic SC,sans-serif;
    font-size: 36px;
    span {
      font-family: Amatic SC,sans-serif;
    }
  }
}
</style>